module.exports = __webpack_public_path__ + "img/print_template_conasi.1e47e724.svg";